import {
  Card,
  Label,
  Stack,
  TextField,
} from "@towersystems/roam-common-native";
import { AddMainProductFormProvider } from "./AddMainProductFormProvider";
import { Controller, useFieldArray, useFormContext } from "react-hook-form";
import { AddMainProductFormValues } from "./types";
import { toTitleCase } from "@towersystems/roam-common/lib/shared-utils";
import { View } from "react-native-ui-lib";

export const AddMainProductForm = () => {
  const { control } = useFormContext<AddMainProductFormValues>();

  const { fields } = useFieldArray({
    control: control,
    name: "selectedOptions",
  });

  return (
    <Card title="Variant Options">
      <Stack vertical>
        {fields.map((field, index) => {
          return (
            <View>
              <Label required label={toTitleCase(field.name)}></Label>
              <Controller
                name={`selectedOptions.${index}.value` as const}
                control={control}
                render={({
                  field: { onChange, value, onBlur },
                  fieldState: { error },
                }) => (
                  <TextField
                    onBlur={onBlur}
                    value={value ?? ""}
                    onChangeText={onChange}
                    validationMessage={error ? error.message : undefined}
                    placeholder="Enter a value"
                  />
                )}
              />
            </View>
          );
        })}
      </Stack>
    </Card>
  );
};

AddMainProductForm.AddMainProductFormProvider = AddMainProductFormProvider;
